import React from 'react';
import {numberWithCommas} from "../../../../utils/methods";

function TakingOrderTotalAmount({price}) {
  return (
    <div className='takingOrder-total'>
      <div style={{minWidth: 200}}>
        <div className='takingOrder-total-container'>
          <div>
            جمع کل
          </div>
          <div>
            {numberWithCommas(`${price}`)}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TakingOrderTotalAmount;
